<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF LAW</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ABOUT US</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool08/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">The Arni school of law</h2>
                <p>Since many years, the ARNI School of Law has been termed as the best place to nurture future leaders
                    in legal practices among many other Law Colleges. The school is designed to deliver profound legal
                    knowledge, analytics abilities, and ethical values. Rooted in a multidisciplinary approach, the ARNI
                    School of Law combines theoretical learning with practical skills, offering comprehensive education
                    in criminal justice, constitutional law, human rights, corporate law, and more. With a strong
                    emphasis on critical thinking, legal research, and experiential learning, the School prepares
                    students to meet the demands of a dynamic legal landscape for those aspiring to bring justice and
                    positive change to society. Arni School of Law has come out as a leading institution in shaping the
                    future of legal professionals by providing a comprehensive understanding of legal principles and
                    practices.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision</b> – Our vision is the become a distinguished place for legal education and practices,
                    research,
                    and advocacy that produce socially conscious and globally competent legal professionals who uphold
                    justice and ethical governance.
                </p>
                <p><b>Mission </b> – Providing a well-rounded legal education that transforms next-generation legal
                    professionals with not only academic knowledge but with real-world experiences. Include them with a
                    strong sense of fairness, ethics, and responsibility towards their profession and society.
                </p>
                <h2>Master’s and Bachelors Degree in Law</h2>
                <p>The School of Law aims to prepare future legal professionals with a solid understanding of law,
                    justice, and ethics. It provides a bachelor of laws program that focuses on legal principles,
                    theories, and methodologies. Students learn critical thinking, logical reasoning, and advocacy
                    skills through coursework and mock trials. The faculty includes experienced practitioners and
                    scholars, and experiential learning opportunities like moot court competitions, internships, and
                    community service programs help students apply theory.
                </p>
                <p><b>Scope </b> - The scope of pursuing a degree in law is vast and diverse. It offers a transformative
                    platform
                    for students, providing them with vast career opportunities for personal and professional growth.
                </p>
                <ul>
                    <li> Opportunities to engage in legal research projects, write for reputed journals and contribute
                        to policy analysis.
                    </li>
                    <li>Studying law can lead to a variety of job options, such as working for the government,
                        nonprofits, or foreign institutions, or becoming a lawyer, judge, legal advisor, corporate
                        counsel, or consultant.
                    </li>
                    <li>Through the use of legal knowledge and experience, it offers a solid basis for people to uphold
                        justice, contribute to society, and have a constructive impact.
                    </li>
                </ul>
                <p>The ARNI School of Law ensures that the students are always ready to tackle real-world legal
                    challenges with the right knowledge, confidence, and competence. Join our courses to shape a society
                    where societal growth and justice are accessible for all.
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">4</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">7</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Legal Studies</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">LL.B</td>
                            </tr>
                            <tr>
                                <td class="time">BA. LL.B</td>
                            </tr>
                            <tr>
                                <td class="time">LLM</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
